// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Commands
// MODIFIED DATE : 07-08-2025

import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	commonLoanProposalListGet,
	createHDFCIndividualLoanQRCode,
	deleteMemberInLoanIndexDetails,
	fetchHolidayList,
	fetchParticularLoanIndexListAPI,
	getMemberLoanProductExistDetails,
	getWholeGroupMemberListGet,
	loanIndexDetailsApprove,
	loanIndexDetailsDelete,
	loanIndexDetailsRevert,
	loanProposalApproveDetailsRevert,
	getAppraisalLogDetails,
	loanApproveOTPDetails,
} from './common-loan-proposal.service';
import CommonLoanProposalActionTypes from './common-loan-proposal.types';
import {
	approveLoanIndexDetailsFailure,
	approveLoanIndexDetailsResponseChanged,
	approveLoanIndexDetailsSuccess,
	deleteLoanIndexDetailsFailure,
	deleteLoanIndexDetailsResponseChanged,
	deleteLoanIndexDetailsSuccess,
	deleteMemberInLoanIndexFailure,
	deleteMemberInLoanIndexResponseChanged,
	deleteMemberInLoanIndexSuccess,
	fetchHolidayListFailure,
	fetchHolidayListResponseChanged,
	fetchHolidayListSuccess,
	fetchParticularLoanIndexFailure,
	fetchParticularLoanIndexResponseChanged,
	fetchParticularLoanIndexSuccess,
	getLoanPropsalListFailure,
	getLoanPropsalListResponseChanged,
	getLoanPropsalListSuccess,
	getMemberLoanProductExistFailure,
	getMemberLoanProductExistResponseChanged,
	getMemberLoanProductExistSuccess,
	getWholeGroupMemberFailure,
	getWholeGroupMemberResponseChanged,
	getWholeGroupMemberSuccess,
	revertLoanIndexDetailsFailure,
	revertLoanIndexDetailsResponseChanged,
	revertLoanIndexDetailsSuccess,
	revertLoanProposalApproveDetailsSuccess,
	revertLoanProposalApproveDetailsFailure,
	revertLoanProposalApproveDetailsResponseChanged,
	createHDFCCreateIndividualLoanQRCodeFailure,
	createHDFCCreateIndividualLoanQRCodeSuccess,
	createHDFCCreateIndividualLoanQRCodeResponseChanged,
	getAppraisalLogResponseChanged,
	getAppraisalLogSuccess,
	getAppraisalLogFailure,
	moveToParticularAppraisalFailure,
	moveToParticularAppraisalResponseChanged,
	moveToParticularAppraisalSuccess,
	loanApproveOTPFailure,
	loanApproveOTPSuccess,
	loanApproveOTPResponseChanged,
} from './common-loan-proposal.action';
import commonLoanProposalActionTypes from './common-loan-proposal.types';

/** *********************  START GET LOAN PROPOSAL LIST  ******************** */
export function* getLoanProposalList({ payload }: any) {
	try {
		const key = 'getLoanIndexListKey';
		const {
			companyID,
			branchID,
			centerID,
			groupID,
			userID,
			userRole,
			userRoleID,
			userLevel,
			loanIndexType,
			databaseName,
			inputSearch,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			UserID: userID,
			UserRole: userRole,
			LoginUserRoleID: userRoleID,
			Level: userLevel,
			LoanIndexType: loanIndexType,
			DatabaseName: databaseName,
			SearchData: inputSearch,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(commonLoanProposalListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLoanPropsalListFailure(responseData.data));
		} else {
			yield put(getLoanPropsalListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLoanPropsalListFailure(error));
	}
}

export function* resetGetLoanProposalListResponse() {
	yield put(getLoanPropsalListResponseChanged());
}

export function* onGetLoanProposal() {
	yield takeLatest(
		CommonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_START,
		getLoanProposalList,
	);
}

export function* onGetLoanProposalListResponseReset() {
	yield takeLatest(
		CommonLoanProposalActionTypes.GET_LOAN_PROPOSAL_LIST_RESPONSE_RESET,
		resetGetLoanProposalListResponse,
	);
}
/** *********************  END GET LOAN PROPOSAL LIST ******************** */

/** *********************  START REVERT LOAN INDEX DETAILS ******************** */

export function* loanIndexRevert({ payload }: any) {
	try {
		const key = 'LoanIndexRevertKey';
		const {
			userID,
			userName,
			companyID,
			databaseName,
			loanIndexID,
			appraisalLevel,
			appraisalApproveSetupID,
			appraisalApproveID,
			isAppraisalApproveNeeded,
			noOfAppraisalApproval,
			appraisalApproveDoneCount,
			appraisalNotes,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			UserName: userName,
			LoanIndexID: loanIndexID,
			AppraisalLevel: appraisalLevel,
			AppraisalDoneBy: userID,
			AppraisalDoneByUserName: userName,
			IsAppraisalApproveNeeded: isAppraisalApproveNeeded,
			AppraisalApproveSetupID: appraisalApproveSetupID,
			AppraisalApproveID: appraisalApproveID,
			NoOfAppraisalApproval: noOfAppraisalApproval,
			AppraisalApproveDoneCount: appraisalApproveDoneCount,
			AppraisalNotes: appraisalNotes,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(loanIndexDetailsRevert, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(revertLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertLoanIndexDetailsFailure(error));
	}
}

export function* resetRevertLoanIndexDetailsResponse() {
	yield put(revertLoanIndexDetailsResponseChanged());
}

export function* onRevertLoanIndexDetails() {
	yield takeLatest(CommonLoanProposalActionTypes.REVERT_LOAN_INDEX_START, loanIndexRevert);
}

export function* onRevertLoanIndexDetailsResponseReset() {
	yield takeLatest(
		CommonLoanProposalActionTypes.REVERT_LOAN_INDEX_RESPONSE_RESET,
		resetRevertLoanIndexDetailsResponse,
	);
}
/** *********************  END REVERT LOAN INDEX DETAILS ******************** */

/**   ******************* GET WHOLE GROUP MEMBER LIST START *************** */
export function* wholeGroupMemberListGet({ payload }: any) {
	try {
		const key = 'GetWholeGroupMemberKey';
		const jsonData = {
			GroupID: payload.groupID,
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			LoanIndex: '-',
			Type: 'New',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getWholeGroupMemberListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getWholeGroupMemberFailure(responseData.data));
		} else {
			yield put(getWholeGroupMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getWholeGroupMemberFailure(error));
	}
}

export function* resetGetWholeGroupMemberResponse() {
	yield put(getWholeGroupMemberResponseChanged());
}

export function* onGetWholeGroupMember() {
	yield takeLatest(
		CommonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_START,
		wholeGroupMemberListGet,
	);
}

export function* onGetWholeGroupMemberResponseReset() {
	yield takeLatest(
		CommonLoanProposalActionTypes.GET_WHOLE_GROUP_MEMBER_LIST_RESPONSE_RESET,
		resetGetWholeGroupMemberResponse,
	);
}
/** *********************  GET WHOLE GROUP MEMBER LIST END  ******************** */

/** ***************** FETCH PARTICULAR LOAN INDEX START *********************** */
export function* fetchParticularLoanIndexList({ payload }: any) {
	try {
		const key = 'FetchParticularLoanIndexKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			loanIndexID: payload.loanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchParticularLoanIndexListAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchParticularLoanIndexFailure(responseData.data));
		} else {
			yield put(fetchParticularLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchParticularLoanIndexFailure(error));
	}
}

export function* resetFetchParticularLoanIndexResponse() {
	yield put(fetchParticularLoanIndexResponseChanged());
}

export function* onFetchParticularLoanIndexDetails() {
	yield takeLatest(
		commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_START,
		fetchParticularLoanIndexList,
	);
}

export function* onFetchParticularLoanIndexResponseReset() {
	yield takeLatest(
		commonLoanProposalActionTypes.FETCH_PARTICULAR_LOAN_INDEX_RESPONSE_RESET_START,
		resetFetchParticularLoanIndexResponse,
	);
}
/** ***************** FETCH PARTICULAR LOAN INDEX END *********************** */

/** ***************** FETCH HOLIDAY LIST START *********************** */
export function* holidayListDetails({ payload }: any) {
	try {
		const key = 'GetHolidayDataKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchHolidayList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchHolidayListFailure(responseData.data));
		} else {
			yield put(fetchHolidayListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchHolidayListFailure(error));
	}
}

export function* resetHolidayListResponse() {
	yield put(fetchHolidayListResponseChanged());
}

export function* onFetchHolidayList() {
	yield takeLatest(commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_START, holidayListDetails);
}

export function* onHolidayListResponseReset() {
	yield takeLatest(
		commonLoanProposalActionTypes.FETCH_HOLIDAY_LIST_RESPONSE_RESET,
		resetHolidayListResponse,
	);
}
/** ***************** FETCH HOLIDAY LIST END *********************** */

/** ***************** GET MEMBER LOAN PRODUCT EXIST START *********************** */
export function* getMemberLoanProductExist({ payload }: any) {
	try {
		const key = 'GetMemberLoanProductExistKey';
		const jsonData = {
			MemberID: payload.MemberID,
			ProductID: payload.ProductID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(getMemberLoanProductExistDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberLoanProductExistFailure(responseData.data));
		} else {
			yield put(getMemberLoanProductExistSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberLoanProductExistFailure(error));
	}
}

export function* resetGetMemberLoanProductExistDetailsResponse() {
	yield put(getMemberLoanProductExistResponseChanged());
}

export function* onGetMemberLoanProductExistDetails() {
	yield takeLatest(
		commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_START,
		getMemberLoanProductExist,
	);
}

export function* onGetMemberLoanProductExistDetailsResponseReset() {
	yield takeLatest(
		commonLoanProposalActionTypes.GET_MEMBER_LOAN_PRODUCT_EXIST_RESPONSE_RESET,
		resetGetMemberLoanProductExistDetailsResponse,
	);
}
/** ***************** GET MEMBER LOAN PRODUCT EXIST START *********************** */

/** ***************** APPROVE LOAN INDEX START *********************** */
export function* approveLoanIndexData({ payload }: any) {
	try {
		const key = 'LoanIndexApproveKey';
		const {
			loanIndexID,
			appraisalLevel,
			userID,
			userName,
			appraisalApproveSetupID,
			appraisalApproveID,
			isAppraisalApproveNeeded,
			isAllApproved,
			noOfAppraisalApproval,
			appraisalNotes,
			companyID,
			databaseName,
		} = payload;
		const jsonData = {
			LoanIndexID: loanIndexID,
			AppraisalLevel: appraisalLevel,
			AppraisalDoneBy: userID,
			AppraisalDoneByUserName: userName,
			AppraisalApproveSetupID: appraisalApproveSetupID,
			AppraisalApproveID: appraisalApproveID,
			IsAppraisalApproveNeeded: isAppraisalApproveNeeded,
			isAllAppraisalApproved: isAllApproved,
			IsAllAppraisalApproved: isAllApproved,
			NoOfAppraisalApproval: noOfAppraisalApproval,
			AppraisalNotes: appraisalNotes,
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(loanIndexDetailsApprove, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(approveLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(approveLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(approveLoanIndexDetailsFailure(error));
	}
}

export function* resetApproveLoanIndexResponseChanged() {
	yield put(approveLoanIndexDetailsResponseChanged());
}

export function* onApproveLoanIndexDetails() {
	yield takeLatest(commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_START, approveLoanIndexData);
}

export function* onApproveLoanIndexResponseResetStart() {
	yield takeLatest(
		commonLoanProposalActionTypes.APPROVE_LOAN_INDEX_RESPONSE_RESET_START,
		resetApproveLoanIndexResponseChanged,
	);
}
/** *****************  APPROVE LOAN INDEX END *********************** */

/** ***************** DELETE LOAN INDEX DETAILS END *********************/
export function* deleteLoanIndexData({ payload }: any) {
	try {
		const key = 'DeleteParticularLoanIndexKey';
		const { companyID, databaseName, userName, userID, loanIndexID, membersCount } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserName: userName,
			UserID: userID,
			LoanIndexID: loanIndexID,
			MembersCount: membersCount,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(loanIndexDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(deleteLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteLoanIndexDetailsFailure(error));
	}
}

export function* resetDeleteLoanIndexDetailsResponse() {
	yield put(deleteLoanIndexDetailsResponseChanged());
}

export function* onDeleteLoanIndexDetails() {
	yield takeLatest(commonLoanProposalActionTypes.DELETE_LOAN_INDEX_START, deleteLoanIndexData);
}

export function* onDeleteLoanIndexDetailsResponseReset() {
	yield takeLatest(
		commonLoanProposalActionTypes.DELETE_LOAN_INDEX_RESPONSE_RESET_START,
		resetDeleteLoanIndexDetailsResponse,
	);
}
/** ***************** DELETE LOAN INDEX DETAILS END *********************/

/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS START *********************/
export function* deleteMemberInLoanIndexData({ payload }: any) {
	try {
		const key = 'DeleteParticularMemberInLoanIndexKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			UserName: payload.userName,
			UserID: payload.userID,
			LoanIndexID: payload.loanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteMemberInLoanIndexDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteMemberInLoanIndexFailure(responseData.data));
		} else {
			yield put(deleteMemberInLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteMemberInLoanIndexFailure(error));
	}
}

export function* resetDeleteMemberInLoanIndexDetailsResponse() {
	yield put(deleteMemberInLoanIndexResponseChanged());
}

export function* onDeleteMemberInLoanIndexDetails() {
	yield takeLatest(
		commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_START,
		deleteMemberInLoanIndexData,
	);
}

export function* onDeleteMemberInLoanIndexDetailsResponseReset() {
	yield takeLatest(
		commonLoanProposalActionTypes.DELETE_MEMBER_IN_LOAN_INDEX_RESPONSE_RESET_START,
		resetDeleteLoanIndexDetailsResponse,
	);
}
/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS END *********************/

/** ***************** REVERT LOAN PROPOSAL APPROVE DETAILS START *********************** */
export function* loanProposalApproveRevert({ payload }: any) {
	try {
		const key = 'LoanIndexApproveRevertKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			UserID: payload.userID,
			UserName: payload.userName,
			LoanIndexID: payload.LoanIndexID,
			AppraisalLevel: payload.AppraisalLevel,
			AppraisalDoneBy: payload.AppraisalDoneBy,
			AppraisalDoneByUserName: payload.AppraisalDoneByUserName,
			IsAppraisalApproveNeeded: payload.IsAppraisalApproveNeeded,
			AppraisalApproveSetupID: payload.AppraisalApproveSetupID
				? payload.AppraisalApproveSetupID
				: 0,
			AppraisalApproveID: payload.AppraisalApproveID ? payload.AppraisalApproveID : 0,
			NoOfAppraisalApproval: payload.NoOfAppraisalApproval
				? payload.NoOfAppraisalApproval
				: 0,
			AppraisalApproveDoneCount: payload.AppraisalApproveDoneCount
				? payload.AppraisalApproveDoneCount
				: 0,
			AppraisalNotes: payload.AppraisalNotes ? payload.AppraisalNotes : '',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(loanProposalApproveDetailsRevert, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertLoanProposalApproveDetailsFailure(responseData.data));
		} else {
			yield put(revertLoanProposalApproveDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertLoanProposalApproveDetailsFailure(error));
	}
}

export function* resetRevertLoanProposalApproveDetailsResponse() {
	yield put(revertLoanProposalApproveDetailsResponseChanged());
}

export function* onRevertLoanProposalApproveDetails() {
	yield takeLatest(
		commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_START,
		loanProposalApproveRevert,
	);
}

export function* onRevertLoanProposalApproveDetailsResponseReset() {
	yield takeLatest(
		commonLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_RESPONSE_RESET,
		resetRevertLoanProposalApproveDetailsResponse,
	);
}
/** ***************** REVERT CUSTOM PRODUCT LOAN DETAILS END *********************** */

/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
export function* addHDFCQRCodeIndivialLoanDeatil({ payload }: any) {
	try {
		const key = 'CreateNewIndividualLoanQRForHDFCKey';
		const { loanIndexID, generalCompanyID, userID, loanIndexUID, databaseName } = payload;
		const jsonData = {
			LoanIndexID: loanIndexID,
			DatabaseName: databaseName,
			CompanyID: generalCompanyID,
			CreatedBy: userID,
			LoanIndexUID: loanIndexUID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createHDFCIndividualLoanQRCode, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createHDFCCreateIndividualLoanQRCodeFailure(responseData.data));
		} else {
			yield put(createHDFCCreateIndividualLoanQRCodeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createHDFCCreateIndividualLoanQRCodeFailure(error));
	}
}

export function* resetcreateHDFCCreateIndividualLoanQRCode() {
	yield put(createHDFCCreateIndividualLoanQRCodeResponseChanged());
}

export function* onResetcreateHDFCCreateIndividualLoanQRCode() {
	yield takeLatest(
		commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_START,
		addHDFCQRCodeIndivialLoanDeatil,
	);
}

export function* onResetcreateHDFCCreateIndividualLoanQRCodeResponseReset() {
	yield takeLatest(
		commonLoanProposalActionTypes.HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_RESPONSE_RESET,
		resetcreateHDFCCreateIndividualLoanQRCode,
	);
}
/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

/*********** GET APPRAISAL LOG START ************************ */
export function* getAppraisalLog({ payload }: any) {
	try {
		const key = 'LoanAppraisalDetailsKey';
		const { companyID, databaseName, loanIndexID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			LoanIndexID: loanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAppraisalLogDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAppraisalLogFailure(responseData.data));
		} else {
			yield put(getAppraisalLogSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAppraisalLogFailure(error));
	}
}
export function* resetGetAppraisalLogResponse() {
	yield put(getAppraisalLogResponseChanged());
}

export function* onGetAppraisalLog() {
	yield takeLatest(commonLoanProposalActionTypes.GET_APPRAISAL_LOG_START, getAppraisalLog);
}

export function* onResetGetAppraisalLogResponse() {
	yield takeLatest(
		commonLoanProposalActionTypes.GET_APPRAISAL_LOG_RESPONSE_RESET,
		resetGetAppraisalLogResponse,
	);
}

/*********** GET APPRAISAL LOG END ************************ */

/*********** MOVE TO PARTICULAR APPRAISAL START ************************ */

export function* moveToParticularAppraisalData({ payload }: any) {
	try {
		const key = 'MoveToParticularAppraisalKey';
		const {
			MemberID,
			MoveAppraisalLevel,
			AppraisalStatus,
			DatabaseName,
			AppraisalNotes,
			AppraisalDoneBy,
			AppraisalDoneByUserName,
			AppraisalApproveSetupID,
			AppraisalApproveID,
			CompanyID,
			AppraisalPage,
		} = payload;
		const jsonData = {
			MemberID,
			MoveAppraisalLevel,
			AppraisalStatus,
			DatabaseName,
			AppraisalNotes,
			AppraisalDoneBy,
			AppraisalDoneByUserName,
			AppraisalApproveSetupID: AppraisalApproveSetupID || 0,
			AppraisalApproveID: AppraisalApproveID || 0,
			CompanyID,
			AppraisalPage,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(moveToParticularAppraisalDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(moveToParticularAppraisalFailure(responseData.data));
		} else {
			yield put(moveToParticularAppraisalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(moveToParticularAppraisalFailure(error));
	}
}

export function* resetMoveToParticularAppraisalResponse() {
	yield put(moveToParticularAppraisalResponseChanged());
}

export function* onMoveToParticularAppraisal() {
	yield takeLatest(
		commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_START,
		moveToParticularAppraisalData,
	);
}

export function* onResetMoveToParticularAppraisalResponse() {
	yield takeLatest(
		commonLoanProposalActionTypes.MOVE_TO_PARTICULAR_APPRAISAL_RESPONSE_RESET,
		resetMoveToParticularAppraisalResponse,
	);
}
/*********** MOVE TO PARTICULAR APPRAISAL END ************************ */

/*********************  LOAN APPROVE OTP ******************** */

export function* loanApproveOTPData({ payload }: any) {
	try {
		const key = 'LoanApproveOTPKey';
		const { loanID, companyID, databaseName, MemberID } = payload;
		const jsonData = {
			LoanIndexGroupMemberID: loanID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(loanApproveOTPDetails, encodeData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(loanApproveOTPFailure(responseData.data));
		} else {
			yield put(loanApproveOTPSuccess(responseData.data));
		}
	} catch (error) {
		yield put(loanApproveOTPFailure(error));
	}
}

export function* resetLoanApproveOTPResponse() {
	yield put(loanApproveOTPResponseChanged());
}

export function* onLoanApproveOTP() {
	yield takeLatest(commonLoanProposalActionTypes.LOAN_APPROVE_OTP_START, loanApproveOTPData);
}

export function* onResetLoanApproveOTPResponse() {
	yield takeLatest(
		commonLoanProposalActionTypes.LOAN_APPROVE_OTP_RESPONSE_RESET,
		resetLoanApproveOTPResponse,
	);
}
/*********************  LOAN APPROVE OTP END ******************** */
export function* commonLoanPrposalSaga() {
	yield all([
		call(onGetLoanProposal),
		call(onGetLoanProposalListResponseReset),
		call(onRevertLoanIndexDetails),
		call(onRevertLoanIndexDetailsResponseReset),
		call(onGetWholeGroupMember),
		call(onGetWholeGroupMemberResponseReset),
		call(onFetchParticularLoanIndexDetails),
		call(onFetchParticularLoanIndexResponseReset),
		call(onFetchHolidayList),
		call(onHolidayListResponseReset),
		call(onGetMemberLoanProductExistDetails),
		call(onGetMemberLoanProductExistDetailsResponseReset),
		call(onApproveLoanIndexDetails),
		call(onApproveLoanIndexResponseResetStart),
		call(onDeleteLoanIndexDetails),
		call(onDeleteLoanIndexDetailsResponseReset),
		call(onDeleteMemberInLoanIndexDetails),
		call(onDeleteMemberInLoanIndexDetailsResponseReset),
		call(onRevertLoanProposalApproveDetails),
		call(onRevertLoanProposalApproveDetailsResponseReset),
		call(onResetcreateHDFCCreateIndividualLoanQRCode),
		call(onResetcreateHDFCCreateIndividualLoanQRCodeResponseReset),
		call(onGetAppraisalLog),
		call(onResetGetAppraisalLogResponse),
		call(onMoveToParticularAppraisal),
		call(onResetMoveToParticularAppraisalResponse),
		call(onLoanApproveOTP),
		call(onResetLoanApproveOTPResponse),
	]);
}
